export class DocumentoDeliveryRequest {
  tipo: String;
  usuario: String;
  documentos: String;
  solicitud: String;
}

